import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import BatchSendComponent from '@/views/correspondence/components/batch-send';
import ExportComponent from '@/views/correspondence/batch/export-component';
import BeforeSendComponent from './before-send';
import HistoryComponent from '@/views/correspondence/batch/history-component';
import DataList from '@/views/correspondence/batch/data-list';
import { mapState } from 'vuex';
export default {
  name: 'correspondence-batch',
  components: {
    DataList: DataList,
    HistoryComponent: HistoryComponent,
    BatchSendComponent: BatchSendComponent,
    ExportComponent: ExportComponent,
    BeforeSendComponent: BeforeSendComponent
  },
  computed: _objectSpread(_objectSpread({}, mapState('cpscc', ['userInfo'])), {}, {
    isHX: function isHX() {
      return this.$store.state.cpscc.isHX;
    },
    isAdmin: function isAdmin() {
      var user = this.userInfo;
      if (user && user.data2) {
        return user.data2.admin;
      }
      return false;
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    isSender: function isSender() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('发函操作员');
        }
      }
      return false;
    }
  }),
  data: function data() {
    return {
      activeName: 'export'
    };
  }
};